import api from './api'

export const getHiddenConnectionAnnouncements = async () => {
  const { data } = await api.get('/users/me/connection-announcements')
  return data.hiddenConnectionAnnouncementIds || []
}

export const updateHiddenConnectionAnnouncement = async ({
  whatsappId,
  hidden
}) => {
  const { data } = await api.put('/users/me/connection-announcements', {
    whatsappId,
    hidden
  })
  return data.hiddenConnectionAnnouncementIds || []
}
